/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reseller relationship information.
 * @export
 * @interface GetServiceprovider200ResponseReseller
 */
export interface GetServiceprovider200ResponseReseller {
    /**
     * Whether this serviceprovider was created by a reseller.
     */
    isCreatedByReseller: boolean;
    /**
     * Reseller UUID, if applicable.
     */
    id?: string;
    /**
     * Whether billing for this serviceprovider is handled by the reseller.
     */
    resellerInvoiced?: boolean;
}

/**
 * Check if a given object implements the GetServiceprovider200ResponseReseller interface.
 */
export function instanceOfGetServiceprovider200ResponseReseller(value: object): value is GetServiceprovider200ResponseReseller {
    if (!('isCreatedByReseller' in value) || value['isCreatedByReseller'] === undefined) return false;
    return true;
}

export function GetServiceprovider200ResponseResellerFromJSON(json: any): GetServiceprovider200ResponseReseller {
    return GetServiceprovider200ResponseResellerFromJSONTyped(json, false);
}

export function GetServiceprovider200ResponseResellerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetServiceprovider200ResponseReseller {
    if (json == null) {
        return json;
    }
    return {
        
        'isCreatedByReseller': json['isCreatedByReseller'],
        'id': json['id'] == null ? undefined : json['id'],
        'resellerInvoiced': json['resellerInvoiced'] == null ? undefined : json['resellerInvoiced'],
    };
}

export function GetServiceprovider200ResponseResellerToJSON(json: any): GetServiceprovider200ResponseReseller {
    return GetServiceprovider200ResponseResellerToJSONTyped(json, false);
}

export function GetServiceprovider200ResponseResellerToJSONTyped(value?: GetServiceprovider200ResponseReseller | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isCreatedByReseller': value['isCreatedByReseller'],
        'id': value['id'],
        'resellerInvoiced': value['resellerInvoiced'],
    };
}

